import { Component, ElementRef, Injector, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { HabilitacaoService, NovaHabilitacao } from "../../habilitacao.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HabilitacaoAlternativa } from "src/app/model/habilitacao-alternativa.model";
import { BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { MensagemService } from "src/app/features/mensagem.service";
import { DatePipe } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import moment from "moment";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";

export class AgenteFinanceiroModelSelect {
  public id: number;
  public nome: string;
  public cnpj: string;
  public sigla: string;
  public disabled: boolean = false;
}

@Component({
    selector: 'app-nova-habilitacao-alternativa',
    templateUrl: './nova-habilitacao-alternativa.component.html',
    styleUrls: ['./nova-habilitacao-alternativa.component.scss'],
    standalone: false
})
export class NovaHabilitacaoAlternativaComponent
  extends BaseEntityComponent<HabilitacaoAlternativa> implements OnInit {

  agentes: AgenteFinanceiroModelSelect[] = [];
  habilitacaoForm: FormGroup;
  novaHabilitacao: boolean = true;
  edicaoHabilitada: boolean = false;
  agenteFinanceiroSelecionado: AgenteFinanceiroModelSelect = null;
  habilitacoes: HabilitacaoAlternativa[] = [];
  habilitacaoSelecionada: HabilitacaoAlternativa;
  dataHoje = new Date();
  idAgente: number;
  justificativaSuspensao: string;
  desabilitaBotaoSuspender: boolean = false;

  @ViewChild('msgTemplateSuspender')
  msgTemplateSuspender: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosSuspender')
  botoesPersonalizadosSuspender: TemplateRef<any>;

  constructor(
    formBuilder: FormBuilder,
    protected injector: Injector,
    private habilitacaoService: HabilitacaoService,
    private mensagemService: MensagemService,
    private bnLoadingService: BnLoadingService,
    private el: ElementRef,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private bnModalService: BnModalMessageService,
  ) {
    super(habilitacaoService);
    this.habilitacaoForm = formBuilder.group({
      agenteFinanceiroId: [null],
      dataInicio: [null, Validators.required],
      dataMaximaValidade: [null, Validators.required],
      valorLimite: [null, [Validators.required, Validators.min(0.01)]],
    });
  }

  ngOnInit(): void {
    this.edicaoHabilitada = false;
    this.activatedRoute.params.subscribe(params => {
      this.idAgente = params['id'];

      this.carregarDados();
    });
  }

  carregarDados() {
    if (this.idAgente) {
      this.novaHabilitacao = false;
      this.habilitacaoService.carregarAgente(this.idAgente).subscribe(agente => {
        this.agenteFinanceiroSelecionado = {id: agente.id , nome: agente.nome, cnpj: agente.cnpj, sigla: agente.sigla, disabled: false};
        this.habilitacaoForm.get('agenteFinanceiroId').setValue(agente.nome);
        this.habilitacaoForm.get('dataInicio').disable();
        this.habilitacaoForm.get('dataMaximaValidade').disable();
        this.habilitacaoForm.get('valorLimite').disable();
      });

      this.carregarHabilitacoes(this.idAgente);
    } else {
      this.novaHabilitacao = true;
      this.carregarAgentes();
    }
  }

  async carregarAgentes() {
    const agentes = await this.habilitacaoService.obterAgentesDisponiveis().toPromise();
    this.agentes = agentes
      .map(a => {
        const { id, nome, cnpj, sigla } = a;
        return {
          id, nome, cnpj, sigla, disabled: a.possuiHabilitacaoAlternativa === true
        }
      });
  }

  async carregarHabilitacoes(idAgente: number) {
    if (idAgente) {
      this.habilitacoes = await this.habilitacaoService.obterPorAgente(idAgente).toPromise();
    }
    this.desabilitarBotaoSuspender();
  }

  desabilitarBotaoSuspender() {
    return this.desabilitaBotaoSuspender = this.habilitacoes.every(hab => hab.situacao === 'SUSPENSO');
  }

  podeSalvar(): boolean {
    return this.habilitacoes.filter(h => h.id == null).length > 0 || this.edicaoHabilitada;
  }

  irParaPesquisa() {
    this.router.navigate(['habilitacao', 'alternativa']);
  }

  incluir() {
    if (this.habilitacaoForm.invalid) {
      this.habilitacaoForm.markAllAsTouched();
      return;
    }
    const {
      agenteFinanceiroId, dataInicio, dataMaximaValidade, valorLimite
    } = this.habilitacaoForm.value;

    const habilitacao: any = {
      agenteFinanceiro: this.agentes.find(a => a.id === agenteFinanceiroId),
      valorLimite: valorLimite,
      dataInicio: dataInicio,
      dataMaximaValidade: dataMaximaValidade,
    }

    if (dataInicio > dataMaximaValidade) {
      this.mensagemService.adicionarMensagemErro('Data início vigência maior que data máxima validação.')
      return;
    }

    const dataInicioStr = this.datePipe.transform(dataInicio, 'dd/MM/yyyy');
    const qtdDentroPeriodoExistente = this.habilitacoes
      .filter(h => this.datePipe.transform(h.dataInicio, 'dd/MM/yyyy') == dataInicioStr
        || (h.dataSuspensao == null && dataInicio > h.dataInicio && dataInicio < h.dataMaximaValidade)).length;
    if (qtdDentroPeriodoExistente > 0) {
      this.mensagemService.adicionarMensagemErro('Habilitação não pode ser adicionada pois já existe outra no mesmo período')
      return;
    }

    this.habilitacoes.push(habilitacao);

    this.habilitacaoForm.get('dataInicio').reset();
    this.habilitacaoForm.get('dataMaximaValidade').reset();
    this.habilitacaoForm.get('valorLimite').reset();

    setTimeout(() => {
      this.removeNgInvalidInput('dataInicio');
      this.removeNgInvalidInput('dataMaximaValidade');
    }, 100);
  }

  removeNgInvalidInput(id: string) {
    const inputElement = this.el.nativeElement.querySelector(`#${id}`);
    inputElement.classList.remove('ng-invalid');
  }

  async salvar() {
    if (this.novaHabilitacao) {
      this.salvarNovo();
    } else {
      this.salvarEdicao();
    }
  }

 async salvarNovo() {
    const habilitacoes: NovaHabilitacao[] = this.habilitacoes
      .filter(h => h.id == null)
      .map((h) => {
        return {
          dataInicio: h.dataInicio,
          dataMaximaValidade: h.dataMaximaValidade,
          valorLimite: h.valorLimite,
        }
      });

    try {
      this.bnLoadingService.bloqueiaTela()
      await this.habilitacaoService.salvar(this.agenteFinanceiroSelecionado.id, habilitacoes).toPromise();
      this.mensagemService.adicionarMensagemSucesso('Habilitação criada/atualizada com sucesso.');
      this.irParaPesquisa();
    } catch (err) {
      console.log(err);
      this.mensagemService.adicionarMensagemErro('Erro ao salvar habilitações');
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }


  salvarEdicao() {
    try {
      const {
        agenteFinanceiroId, dataInicio, dataMaximaValidade, valorLimite
      } = this.habilitacaoForm.value;

      if (dataInicio > dataMaximaValidade) {
        this.mensagemService.adicionarMensagemErro('Data início vigência maior que data máxima validação.')
        return;
      }

      this.bnLoadingService.bloqueiaTela();

      this.habilitacaoSelecionada.dataInicio = this.habilitacaoForm.get('dataInicio').value;
      this.habilitacaoSelecionada.dataMaximaValidade = this.habilitacaoForm.get('dataMaximaValidade').value;
      this.habilitacaoSelecionada.valorLimite = this.habilitacaoForm.get('valorLimite').value;

      this.habilitacaoService.editar(this.habilitacaoSelecionada).subscribe(response => {
        this.mensagemService.adicionarMensagemSucesso('Habilitação criada/atualizada com sucesso.');

        this.carregarDados();

        this.habilitacaoForm.get('dataInicio').reset();
        this.habilitacaoForm.get('dataMaximaValidade').reset();
        this.habilitacaoForm.get('valorLimite').reset();

        this.habilitacaoForm.get('dataInicio').disable();
        this.habilitacaoForm.get('dataMaximaValidade').disable();
        this.habilitacaoForm.get('valorLimite').disable();
        this.edicaoHabilitada = false;
      });
    } catch (err) {
      console.log(err);
      this.mensagemService.adicionarMensagemErro('Erro ao salvar habilitações');
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

  desabilitaOpcao(agente: AgenteFinanceiroModelSelect) {
    return agente.disabled === true;
  }

  selecionar(agente: AgenteFinanceiroModelSelect) {
    this.agenteFinanceiroSelecionado = agente;
    this.carregarHabilitacoes(this.agenteFinanceiroSelecionado.id);
  }

  remover(index: number) {
    this.habilitacoes.splice(index, 1);
  }

  iniciarEdicao(item: HabilitacaoAlternativa) {
    this.habilitacaoSelecionada = new HabilitacaoAlternativa();
    Object.assign(this.habilitacaoSelecionada, item);
    this.edicaoHabilitada = true;

    this.habilitacaoForm.get('dataInicio').disable();
    this.habilitacaoForm.get('dataMaximaValidade').enable();
    this.habilitacaoForm.get('valorLimite').enable();

    if (moment().isBefore(moment(this.habilitacaoSelecionada.dataInicio)) ) {
      this.habilitacaoForm.get('dataInicio').enable();
      this.habilitacaoForm.get('dataInicio').setValue(moment(this.habilitacaoSelecionada.dataInicio).toDate());
    } else {
      this.habilitacaoForm.get('dataInicio').setValue(moment().add(1, 'day'));
    }

    this.habilitacaoForm.get('dataMaximaValidade').setValue(moment(item.dataMaximaValidade).toDate());
    this.habilitacaoForm.get('valorLimite').setValue(item.valorLimite);
  }

  abrirSuspender(item: HabilitacaoAlternativa) {
    this.justificativaSuspensao = null;

    this.bnModalService.abrir(
      'Confirmação',
      'Deseja suspender a habilitação?',
      'lg',
      this.msgTemplateSuspender,
      this.botoesPersonalizadosSuspender
    );
  }

  suspender() {
    if (!this.justificativaSuspensao) {
      this.mensagemService.adicionarMensagemErro('Informe a justificativa.')
      return;
    }

    this.habilitacaoService.suspender(this.idAgente, this.justificativaSuspensao).subscribe(response => {
      this.habilitacaoSelecionada = null;
      this.justificativaSuspensao = null;
      this.dismissModal();
      this.carregarDados();
    });
  }

  dismissModal() {
    this.bnModalService.dismiss();
  }

  podeEditar(item: HabilitacaoAlternativa, index: number) {
    return !this.novaHabilitacao && !this.edicaoHabilitada && item.dataSuspensao == null && this.validaSubstituto(item, index);
  }

  validaSubstituto(item: HabilitacaoAlternativa, index: number) {
    let dataAtual = moment(item.dataMaximaValidade);
    let proximo = this.habilitacoes[index + 1];

    return !proximo || dataAtual.isAfter( proximo.dataInicio);
  }
}
